function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.71 24h14.58a1 1 0 00.872-1.49l-7.29-12.96a1 1 0 00-1.744 0l-7.29 12.96A1 1 0 008.71 24z",
  fill: "#B8C3D9"
});

var SvgIconTriNormal = function SvgIconTriNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNzA5ODUgMjRIMjMuMjkwMkMyNC4wNTUgMjQgMjQuNTM2NyAyMy4xNzYzIDI0LjE2MTcgMjIuNTA5N0wxNi44NzE2IDkuNTQ5NDdDMTYuNDg5MyA4Ljg2OTgyIDE1LjUxMDcgOC44Njk4MiAxNS4xMjg0IDkuNTQ5NDdMNy44MzgyNyAyMi41MDk3QzcuNDYzMzEgMjMuMTc2MyA3Ljk0NTAyIDI0IDguNzA5ODUgMjRaIiBmaWxsPSIjQjhDM0Q5Ii8+Cjwvc3ZnPgo=";
export { SvgIconTriNormal as ReactComponent };